export default __webpack_public_path__ + "static/media/blog-2.ba450f0c.jpg";